
















    import { TyMarketplace } from '@/classes/TayehApi'
import { BannerSize, GetTayehMarketplaceShopBannerResponse } from '@/classes/TayehApi/TyMarketplace'
import MarketplaceBanner from '../MarketplaceBanner.vue'
import { Carousel, Slide } from 'vue-carousel';
import {
        Component,
        Vue
    } from 'vue-property-decorator'
    import Banner from '../MarketplaceBanner.vue'
    @Component({
        components: {
            Banner,
            MarketplaceBanner,
            Carousel,
            Slide
            
        }
    })
    export default class MarketplaceShopProfileBanners extends Vue {
        private banners: GetTayehMarketplaceShopBannerResponse[] = null;
        async getShopBanners () {
            const res = await TyMarketplace.getTyMarketplaceShopBanners(this.$route.params.shop_username, {size: BannerSize.ALL});
            console.log('banners',res.data);
            
            this.banners = res.data;
        }
        mounted() {
            this.getShopBanners()
        }
    }
